$(".content-page")
  .children("h2")
  .each(function() {
    let name = $(this)
      .text()
      .toLowerCase();
    let res = name.split(" ").join("-");
    $(this).attr("id", res);
    $(this).attr("data-scroll", res);
  });

$("[data-scroll]").each(function() {
  let element = $(this);
  let id = element.attr("data-scroll");
  let correctName;
  if (id.split("-")[1] === "container") {
    correctName = id.split("-")[0];
  } else {
    correctName = id.split("-").join(" ");
  }
  if (id === "general-info" || id === "format") {
    $(".scroll-navigation__list").append(
      `<li class="scroll-navigation__list-item"><a href=#${id} class="scroll-navigation__link" data-swiper>${correctName}</a></li>`
    );
  } else {
    $(".scroll-navigation__list").append(
      `<li class="scroll-navigation__list-item"><a href=#${id} class="scroll-navigation__link">${correctName}</a></li>`
    );
  }
});

$(".scroll-navigation__list-item")
  .first()
  .addClass("active");

$('a[href*="#"]').on("click", function(e) {
  e.preventDefault();
  $("html, body").animate(
    {
      scrollTop: $($(this).attr("href")).offset().top - 42 + "px",
    },
    1500,
    "linear"
  );
  $(".scroll-navigation__list-item").removeClass("active");
  $(this)
    .parent(".scroll-navigation__list-item")
    .addClass("active");
});



// WEBPACK FOOTER //
// ./scripts/components/scroll-navigation.js